import React from 'react'

const TopicCard = ({topic, user, movieName}) => {
    return (
        <div className="topicCard">
            <img src={user.userImg} alt={user.nome} />
            <div className="topicCard__text">
                <strong>{user.nome}</strong>
                <h3>{topic.title}</h3>
                <em>{movieName}</em>
                <p>
                    {topic.msg}
                </p>
            <div className="topicCard__controls">
                <div className="topicCard__controls__like">
                    <i className="fa fa-thumbs-up" aria-hidden="true"></i>
                    <i className="fa fa-thumbs-down" aria-hidden="true"></i>
                </div>
                <div className="topicCard__controls__comment">
                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                    {topic.comments.length} comentários
                </div>
            </div>
            </div>
        </div>
    )
}

export default TopicCard
